import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { SalarieCompetenceDto } from "../../../../../dto/GenApi.iNotPaie.Dto/SalarieCompetenceDto";
import $ from "jquery";
import moment from "moment";
import { FormationDto } from "../../../../../dto/GenApi.iNotPaie.Dto/FormationDto";

@Component
export default class ModalAjouterFormation extends Vue {
	@Prop()
	public salarie?: SalarieCompetenceDto = undefined;

	public estAjout = false;
	public formation?: FormationDto = undefined;

	public DateDebut?: string = "";
	public DateFin?: string = "";
	public Intitule?: string = "";
	public NombreJours?: number = 0;
	public Plan?: string = "";
	public Acquisition?: number = 0;
	public ProchaineDate?: string = "";

	public onFormationChange(): void {
    	if (this.formation == undefined) {
			return;
		}

    	this.DateDebut = this.formation.DateDebut != undefined ? moment.utc(this.formation.DateDebut).format("YYYY-MM-DD") : "";
    	this.DateFin = this.formation.DateFin != undefined ? moment.utc(this.formation.DateFin).format("YYYY-MM-DD") : "";
    	this.Intitule = this.formation.Intitule;
    	this.NombreJours = this.formation.NombreJours;
    	this.Plan = this.formation.Plan;
    	this.Acquisition = this.formation.Acquisition;
    	this.ProchaineDate = this.formation.ProchaineDate != undefined ? moment.utc(this.formation.ProchaineDate).format("YYYY-MM-DD") : "";
	}

	public initialize(formation: FormationDto, estAjout: boolean, salarie?: SalarieCompetenceDto): void {
    	this.salarie = salarie;
    	this.estAjout = estAjout;
    	this.formation = formation;

    	this.onFormationChange();
	}

	public enregistrer(): void {
    	if (this.salarie == undefined || this.formation == undefined) {
			return;
		}
    	this.formation.DateDebut = this.DateDebut != "" ? moment.utc(this.DateDebut).toDate() : undefined;
    	this.formation.DateFin = this.DateFin != "" ? moment.utc(this.DateFin).toDate() : undefined;
    	this.formation.Intitule = this.Intitule;
    	this.formation.NombreJours = this.NombreJours;
    	this.formation.Plan = this.Plan;
    	this.formation.Acquisition = this.Acquisition;
    	this.formation.ProchaineDate = this.ProchaineDate != "" ? moment.utc(this.ProchaineDate).toDate() : undefined;

    	this.$emit(this.estAjout ? "ajout" : "update", { formation: this.formation });
    	$("#modalAjouterFormation").modal("hide");
	}

	public annuler(): void {
    	$("#modalAjouterFormation").modal("hide");
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/competences/modals/ajouterFormation/ajouterFormation.ts